const settings = {
  title: 'Settings',
  subtitle: 'Manage your account preferences and application settings',
  saveSettings: 'Save Settings',
  saveSuccess: 'Your settings have been saved successfully',

  sections: {
    appearance: 'Appearance',
    notifications: 'Notifications',
    privacy: 'Privacy',
    account: 'Account',
  },

  appearance: {
    title: 'Appearance',
    description: 'Customize how the application looks and feels',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    language: 'Language',
  },

  notifications: {
    title: 'Notifications',
    description: 'Choose what notifications you want to receive',
    emailAlerts: 'Email Alerts',
    emailAlertsDesc: 'Receive important updates via email',
    priceDrops: 'Price Drop Alerts',
    priceDropsDesc: 'Get notified when prices drop on saved properties',
    newListings: 'New Listing Alerts',
    newListingsDesc: 'Be the first to know about new properties',
    savedSearches: 'Saved Search Alerts',
    savedSearchesDesc: 'Updates when new properties match your searches',
    marketingEmails: 'Marketing Emails',
    marketingEmailsDesc: 'Promotional offers and newsletters',
  },

  privacy: {
    title: 'Privacy',
    description: 'Control your privacy and data settings',
    showProfile: 'Public Profile',
    showProfileDesc: 'Allow others to view your profile',
    showFavorites: 'Show Favorites',
    showFavoritesDesc: 'Let others see your favorite properties',
    allowAnalytics: 'Usage Analytics',
    allowAnalyticsDesc: 'Help us improve by sharing usage data',
    dataManagement: 'Data Management',
    downloadData: 'Download My Data',
    deleteData: 'Delete All Data',
    exportError: 'Failed to export your data. Please try again.',
  },

  account: {
    title: 'Account',
    description: 'Manage your account and security settings',
    noName: 'No name set',
    memberSince: 'Member since {{date}}',
    editProfile: 'Edit Profile',
    editProfileDesc: 'Update your personal information',
    changePassword: 'Change Password',
    passwordChangeComingSoon: 'Password change functionality is coming soon.',
    changePasswordDesc: 'Update your account password',
    twoFactor: 'Two-Factor Authentication',
    twoFactorDesc: 'Add an extra layer of security',
    comingSoon: 'Coming Soon',
    dangerZone: 'Danger Zone',
    signOut: 'Sign Out',
    deleteAccount: 'Delete Account',
    deleteConfirm: 'Delete your account? Your personal data is anonymised within 30 days; records required by law (invoices, transactions) are retained. This cannot be undone.',
    deleteSuccess: 'Your account has been deleted.',
    deleteError: 'Failed to delete account. Please try again or contact support.',
    notSignedIn: 'Not Signed In',
    signInToManage: 'Sign in to manage your account settings',
  },
};

export default settings;
